module.exports = __webpack_public_path__ + "5ed4c2bfea1fb29588148e0451760d85.svg";